import { useQueryStateContext, useVisualComponentsContext } from '../../contexts';
import { useTranslation } from '../../hooks/useTranslation';
import { Combinator } from '../../types';

type CombinatorInputProps = {
  isInvalid?: boolean;
  onChange: (value: Combinator | null) => void;
  placeholder?: string;
  value: Combinator | null;
};

export const CombinatorInput = ({ isInvalid = false, onChange, value }: CombinatorInputProps) => {
  const { t } = useTranslation();
  const { isReadOnly = false } = useQueryStateContext();
  const { RequirementCombinatorSelect: VisualComponent } = useVisualComponentsContext();

  return (
    <VisualComponent
      hasError={isInvalid}
      isDisabled={isReadOnly}
      onChange={onChange}
      placeholder={t('v2.requirementBuilder.combinatorPlaceholder')}
      value={value}
    />
  );
};
